var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6871 1.5H6.37047C6.23586 1.5 6.16855 1.5 6.10913 1.5205C6.05658 1.53862 6.00872 1.5682 5.96901 1.60709C5.92411 1.65107 5.89401 1.71127 5.83381 1.83167L2.68381 8.13167C2.54005 8.41919 2.46817 8.56295 2.48543 8.67981C2.50051 8.78185 2.55695 8.87318 2.64148 8.9323C2.73828 9 2.89901 9 3.22046 9H7.87465L5.62464 16.5L14.7695 7.01648C15.078 6.69653 15.2323 6.53655 15.2413 6.39966C15.2491 6.28084 15.2 6.16536 15.1091 6.08852C15.0043 6 14.782 6 14.3376 6H8.99965L10.6871 1.5Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.19818796f2423c6e9362f59c7fc68de1.svg";
export { ForwardRef as ReactComponent };